export function phoneDigits(v: unknown): string {
  return String(v ?? "").replace(/\D/g, "");
}

export function formatPhoneDisplay(mobile: unknown): string {
  const d = phoneDigits(mobile);
  if (d.length !== 10) return String(mobile ?? "");
  return `(${d.slice(0, 3)})-${d.slice(3, 6)}-${d.slice(6)}`;
}

/** Formats up to 10 digits as (000)-000-0000 while the user types. */
export function formatUsPhoneTyping(input: unknown): string {
  const d = phoneDigits(input).slice(0, 10);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)})-${d.slice(3)}`;
  return `(${d.slice(0, 3)})-${d.slice(3, 6)}-${d.slice(6)}`;
}

export function formatE164Display(e164: string | null | undefined): string {
  if (!e164) return "—";
  const d = phoneDigits(e164);
  if (d.length === 11 && d.startsWith("1")) {
    return `+1 ${formatPhoneDisplay(d.slice(1))}`;
  }
  return e164;
}
